module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA6BAMAAAAeiydcAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUdwTP///2jOzCa6uf///5Pd3KDh4FbKycbt7TkqOkgAAAADdFJOUwB/f5JrzUoAAAC5SURBVDjL3ZTbEcIgEEVpIXZgWrjBFBB2LICUYAfagbFvg4GEXczOOI4feL+YPXN4gzFfpYlpj82aQ5taxi0hnNwaj0tsJTwAGwa6CvAZSm7mquHeQM0/487tZKgQTyomq2KPUcEEWAV7Fc+y1nmS3+NV5phGIXPsrZAZpljdZIbvSzmTpR3qmSzGDiCXxcwDyWWx7hn1uSwwva6u3b0OHkyWmLhc7LlncoGJyeWJPabaH9EH+Hc/0xMKqY80Qe6QrQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notification/booking_accepted.png
// module id = 1811
// module chunks = 0